// Root React app. Keeps the landing hub redirect behavior for the site root
// and mounts Brand OS at /brand-os/*. Landing-hub HTML pages continue to be
// served as static files from /public and are reachable at their own URLs
// (/precipice.html, /roadmap.html, /admin.html, /charter.html, etc).
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";
import BrandOSApp from "./brandos/App";
import SharedDiscoverySummary from "./brandos/pages/SharedDiscoverySummary";
// HIDDEN 2026-11-01 (Roger): the public "Try Brand OS on your URL" trial is not
// ready. Its result page (/discover/:discoveryId, pages/PublicDiscoverySummary.jsx)
// is kept in the tree but unrouted — unknown paths fall through to the landing
// redirect — until the trial is switched back on (see routes/genesis.py).

function LandingRedirect() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Preserve the landing hub redirect the site relied on previously.
      window.location.replace("/landing.html");
    }
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/brand-os/*" element={<BrandOSApp />} />
        <Route path="/discover/shared/:shareToken" element={<SharedDiscoverySummary />} />
        <Route path="*" element={<LandingRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
